// extracted by mini-css-extract-plugin
export default {"shell":"vKn2mpAR","main":"vaIy2xM1","inner":"Gj3TADkL"};